import React from 'react';
import { Col, Row } from 'reactstrap';

import ResetPasswordForm from './resetPasswordForm';

class ResetPasswordView extends React.Component {
  render() {
    return (
      <div className="reset-password-container">
        <div className="login-container text-center">
          <Row className="p-0 m-0 lala">
            {/* image */}
            <Col md={6} className="d-none d-md-block p-0 login-image-container">
              <h1>The only tool for the USAF-wide PFE/SKT exam.</h1>
            </Col>

            {/* form */}

            <Col xs={12} md={6} className="login-form-container">
              <ResetPasswordForm
                resetPassword={this.props.resetPassword}
                message={this.props.message}
                successful={this.props.successful}
                errors={this.props.errors}
                isLoading={this.props.isLoading}
                setMessage={this.props.setMessage}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default ResetPasswordView;
